module.exports = __webpack_public_path__ + "static/media/mentor-others.afd6eb04.svg";